// ROUTES
export const ROUTE_LIST = 'admin2.mfr-restrict.list';
export const ROUTE_CREATE = 'admin2.mfr-restrict.create';
export const ROUTE_UPDATE = 'admin2.mfr-restrict.update';

// STORAGE KEYS
export const MFR_RESTRICTIONS_LIST_STORAGE_KEY = 'admin-mfr-restrict-list';
export const MFR_RESTRICTIONS_LIST_VIEW_KEY = 'tv-admin-mfr-restrict-list';

// DATA TYPES
export const MFR_RESTRICTIONS_STATUS_ACTIVE = 'ACTIVE';
export const MFR_RESTRICTIONS_STATUS_INACTIVE = 'INACTIVE';

// ENDPOINTS
export const MFR_RESTRICTIONS_SAVE = 'admin/mfrestrict/save';

// {
//     "EditIds": [
//         "68700abdc275e91a7ccd3c31",
//         "68700ab77eb53cabe29c37eb"
//     ],
//     "ParentCo": "",
//     "CeRestrictTypes": [
//         "ALL"
//     ],
//     "ExemptStates": [
//         "NONE"
//     ]
// }

// {
//     "EditIds": [
//         "68700ab77eb53cabe29c37eb",
//         "68700abdc275e91a7ccd3c31"
//     ],
//     "ParentCo": "GGGG",
//     "CeRestrictTypes": [],
//     "ExemptStates": []
// }
